module.exports = __webpack_public_path__ + "img/Illustration.10ab8f50.png";